export default __webpack_public_path__ + "static/media/play.39cc7b32.svg";